import * as storageKeys from '@/consts/app/storageKeys';
import storageService from '@/services/storage/storageService';

import localStorageClient from './localStorageClient';

const setSubscriptionToLocalStorage = (data) =>
    localStorageClient.setItem(storageKeys.PUSH_NOTIFICATION_SUBSCRIPTION_DATA, data);
const getSubscriptionFromLocalStorage = () =>
    localStorageClient.getItem(storageKeys.PUSH_NOTIFICATION_SUBSCRIPTION_DATA);
const removeSubscriptionFromLocalStorage = () =>
    localStorageClient.removeItem(storageKeys.PUSH_NOTIFICATION_SUBSCRIPTION_DATA);

const getNotificationSettings = () => {
    return localStorageClient.getItem(storageKeys.NOTIFICATION_SETTINGS) || {};
};

const setNotificationSettings = (settings) => {
    localStorageClient.setItem(storageKeys.NOTIFICATION_SETTINGS, settings);
};

const getIsNotificationPromptClosed = () => {
    const settings = getNotificationSettings();

    return (
        !!settings.isNotificationPromptClosed ||
        // Backward compatibility
        !!localStorageClient.getItem(storageKeys.IS_NOTIFICATION_PERMISSION_DENIED)
    );
};

const setIsNotificationPromptClosed = (value) => {
    const settings = getNotificationSettings();

    setNotificationSettings({
        ...settings,
        isNotificationPromptClosed: value,
    });
};

const getIsPushNotificationDisabled = () => {
    const settings = getNotificationSettings();

    return !!settings.isPushNotificationDisabled;
};

const setIsPushNotificationDisabled = (value) => {
    const settings = getNotificationSettings();

    setNotificationSettings({
        ...settings,
        isPushNotificationDisabled: value,
    });
};

const setPushNotificationPromptDataToLocalStorage = (data) =>
    storageService.setConsumerItem(storageKeys.PUSH_NOTIFICATION_PROMPT_DATA, data);
const getPushNotificationPromptDataToLocalStorage = () =>
    storageService.getConsumerItem(storageKeys.PUSH_NOTIFICATION_PROMPT_DATA);

export default {
    setSubscriptionToLocalStorage,
    getSubscriptionFromLocalStorage,
    removeSubscriptionFromLocalStorage,
    getNotificationSettings,
    setNotificationSettings,
    getIsNotificationPromptClosed,
    setIsNotificationPromptClosed,
    getIsPushNotificationDisabled,
    setIsPushNotificationDisabled,
    setPushNotificationPromptDataToLocalStorage,
    getPushNotificationPromptDataToLocalStorage,
};
